import { render, staticRenderFns } from "./RichBox.vue?vue&type=template&id=41755db6&scoped=true&"
import script from "./RichBox.vue?vue&type=script&lang=js&"
export * from "./RichBox.vue?vue&type=script&lang=js&"
import style0 from "./RichBox.vue?vue&type=style&index=0&id=41755db6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41755db6",
  null
  
)

export default component.exports